import { RouterProvider } from 'react-router-dom'
import { Toaster } from '@/components/ui/sonner'
import { BrandProvider } from '@/brand/BrandProvider'
import { AuthProvider } from '@/contexts/AuthContext'
import { valuationRouter } from '@/router/valuation'

/**
 * VAL-DEPLOY-UNIT-1 — standalone Valuation build's App shell.
 *
 * Identical shape to AttestApp.tsx (BrandProvider > AuthProvider >
 * RouterProvider + Toaster) — none of that is product-specific, per the
 * reused ATTEST-DEPLOY-UNIT-1 answer. The only difference is the router:
 * `@/router/valuation` (trimmed) instead of `@/router` (the full QoE
 * monolith) or `@/router/attest`.
 */
export default function ValuationApp() {
  return (
    <BrandProvider>
      <AuthProvider>
        <RouterProvider router={valuationRouter} />
        <Toaster />
      </AuthProvider>
    </BrandProvider>
  )
}
